module.exports = __webpack_public_path__ + "static/img/13.9bd2234.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/sp/13.png
// module id = ++P4
// module chunks = 0